/// <reference path="../../../src/types.d.ts" />
import { CODAMETRIX } from '../../views/organizations/stub-organization';
import { LOAD_STATES } from '../common';
import { defaultFilterableOptions } from '../../core/default-filterable-options';
import { commonEnums as enums, cmxDateTime } from '@codametrix/ui-common';
import { logTypeCriteria, dateCriteria } from '../audit-log/audit-log-field-definitions';
import { AmplifyCore } from '@codametrix/ui-common';
const { paginationUtils } = AmplifyCore;
const { FilterTypes } = enums;
export const auditLogListPath = {
    displayName: 'Audit Log',
    path: '/cmx/admin/auditLog/'
};
const defaultDateFilter = {
    key: `date_of_service`,
    type: `BETWEEN`,
    from: cmxDateTime.format(new Date(), cmxDateTime.FORMATS.DATE, {
        throw: false,
        localized: true,
        offset: {
            action: cmxDateTime.DateManipulateOperation.SUBTRACT,
            delta: [
                2,
                cmxDateTime.DateManipulateUnit.DAY
            ]
        }
    }),
    to: cmxDateTime.format(new Date(), cmxDateTime.FORMATS.DATE)
};
export const defaultSortablePageable = {
    pageableDefinition: {
        ...paginationUtils.emptyPageable
    },
    sortableOptions: [
        {
            sortField: 'eventDate',
            sortDirection: 'DESC'
        }
    ],
    filterableOptions: {
        dateFilter: defaultDateFilter,
        ...defaultFilterableOptions
    }
};
const tenantIdCriteria = {
    label: 'Tenant ID',
    key: 'tenantId',
    helpText: '',
    placeholder: 'Tenant Id',
    required: true,
    type: FilterTypes.LIKE,
    isSelected: true
};
const dictionaryCriteria = {
    label: 'Dictionary',
    key: 'dictionary',
    helpText: '',
    placeholder: 'Dictionary',
    required: true,
    type: FilterTypes.LIKE,
    isSelected: true
};
const organizationNameCriteria = {
    label: 'Organization',
    key: 'organizationName',
    helpText: '',
    placeholder: 'Organization',
    required: true,
    type: FilterTypes.LIKE,
    isSelected: true
};
const usernameCriteria = {
    label: 'Username',
    key: 'username',
    helpText: '',
    placeholder: 'Username',
    required: true,
    type: FilterTypes.LIKE,
    isSelected: true
};
export const auditLogCriteriaFilter = {
    filters: [],
    dateFilter: defaultDateFilter,
    filterForms: [
        logTypeCriteria,
        dateCriteria
    ],
    searchForms: [
        usernameCriteria,
        dictionaryCriteria,
        organizationNameCriteria,
        tenantIdCriteria
    ]
};
const remoteFilters = [];
const localFilters = [];
const filterLoadStates = {};
remoteFilters.forEach((key)=>{
    filterLoadStates[key] = LOAD_STATES.initial;
});
localFilters.forEach((key)=>{
    filterLoadStates[key] = LOAD_STATES.done;
});
export const auditLog = {
    label: 'audit_log',
    itemName: 'audit_log',
    auditLogs: [],
    rootContext: CODAMETRIX,
    sortablePageable: defaultSortablePageable,
    loadState: LOAD_STATES.done,
    columnDefs: [],
    criteriaFilter: auditLogCriteriaFilter,
    filterLoadStates
};
